import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Button, Icon } from 'shared/components';
import { InputWithCharacterCounter } from 'modules/common/components';
import mediaType from 'modules/appointmentInfo/components/MediaGallery/mediaType';

import theme from './ModalEditFileName.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onModalDismiss: PropTypes.func.isRequired,
  fileSrc: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  fileType: PropTypes.string.isRequired,
  maxLength: PropTypes.number.isRequired,
};

const defaultProps = {};

const descriptiveTitle = { id: 'PatientPortal.Modal.ModalUpdateUploadFile.Body.Descriptive.title', defaultMessage: '** Please add a descriptive Title' };
const headerMessage = { id: 'Media.Update.UpdateFileNameDialog.Title', defaultMessage: '** Edit file name' };
const cancelMessage = { id: 'General.Cancel', defaultMessage: '** Cancel' };
const okMessage = { id: 'General.Save', defaultMessage: '** Save' };

class ModalEditFileName extends PureComponent {
  state = {
    fileName: this.props.fileName || '',
  };

  componentWillUnmount() {
    const { fileName } = this.state;
    this.props.onModalDismiss(fileName);
  }

  onFileNameChange = fileName => {
    this.setState({ fileName });
  };

  onSubmit = () => {
    this.props.onOk(this.state.fileName);
  };

  render() {
    const { onSubmit, onFileNameChange } = this;
    const { fileName } = this.state;
    const { intl, onCancel, fileSrc, fileType, maxLength } = this.props;

    return (
      <div role="dialog" aria-modal="true" aria-label={ intl.formatMessage(headerMessage) } className={ theme.root }>
        <div className={ theme.header }>
          <span className={ theme.message }>
            <FormattedMessage { ...headerMessage } />
          </span>
          <button onClick={ onCancel } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
            <Icon name="naked-x" />
          </button>
        </div>

        <div className={ theme.main }>
          <div className={ theme.descriptive }>
            <span aria-hidden>
              <FormattedMessage { ...descriptiveTitle } />
            </span>


            <InputWithCharacterCounter
              ariaLabel={ intl.formatMessage(descriptiveTitle) }
              testId="modal-edit-file-name-field"
              defaultValue={ fileName }
              iconPositionRtlNotReversed={ true }
              size="large"
              mediaResized={ true }
              autoFocus={ true }
              maxLength={ maxLength }
              onChange={ onFileNameChange }
              placeholder={{
                defaultMessage: ' ',
                id: 'default',
              }}
            />
          </div>

          <div className={ classnames(theme.imgPreview, {
            [theme.iconPreview]: fileType === mediaType.PDF,
          }) }
          >

            { fileType === mediaType.PDF
              ? <Icon className={ theme.iconType } name="pdf-file" />
              : <img alt={ fileName } src={ fileSrc } />
            }

          </div>
        </div>

        <div className={ theme.footer }>
          <Button
            testId="modal-edit-file-name-cancel-button"
            buttonType="naked"
            label={ intl.formatMessage(cancelMessage) }
            className={ theme.cancelButton }
            labelColor="blackMedium"
            onClick={ onCancel }
          />

          <Button
            testId="modal-edit-file-name-confirm-button"
            label={ intl.formatMessage(okMessage) }
            className={ theme.uploadButton }
            iconName="check"
            onClick={ onSubmit }
            iconPositionLeft
          />
        </div>
      </div>
    );
  }
}


ModalEditFileName.propTypes = propTypes;
ModalEditFileName.defaultProps = defaultProps;

export default ModalEditFileName;
